/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Basegame2Inputs */

const id_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game Dasar`)
};

const ms_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permainan Asas`)
};

const da_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basespil`)
};

const de_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basisspiel`)
};

const en_us2_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base Game`)
};

const es_es2_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego base`)
};

const es_mx2_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juego base`)
};

const fil_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base Game`)
};

const fr_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeu de base`)
};

const it_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioco base`)
};

const hu_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alapjáték`)
};

const nl_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basespel`)
};

const no_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grunnspill`)
};

const pl_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gra podstawowa`)
};

const pt_br2_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo básico`)
};

const pt_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogo base`)
};

const ro_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Joc de bază`)
};

const fi_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruspeli`)
};

const sv_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grundspel`)
};

const vi_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game cơ bản`)
};

const tr_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temel Oyun`)
};

const cs_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Základní hra`)
};

const bg_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Основна игра`)
};

const ru_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базовая игра`)
};

const uk_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Базова гра`)
};

const ar_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللعبة الأساسية`)
};

const hi_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बेस गेम`)
};

const th_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เกมหลัก`)
};

const ja_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベースゲーム`)
};

const zh_cn2_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基础游戏`)
};

const zh_hant1_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基礎遊戲`)
};

const ko_offerdetail_achievements_basegame2 = /** @type {(inputs: Offerdetail_Achievements_Basegame2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기본 게임`)
};

/**
* | output |
* | --- |
* | "Base Game" |
*
* @param {Offerdetail_Achievements_Basegame2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_basegame2 = /** @type {((inputs?: Offerdetail_Achievements_Basegame2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Basegame2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_basegame2(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_basegame2(inputs)
	if (locale === "da") return da_offerdetail_achievements_basegame2(inputs)
	if (locale === "de") return de_offerdetail_achievements_basegame2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_basegame2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_basegame2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_basegame2(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_basegame2(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_basegame2(inputs)
	if (locale === "it") return it_offerdetail_achievements_basegame2(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_basegame2(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_basegame2(inputs)
	if (locale === "no") return no_offerdetail_achievements_basegame2(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_basegame2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_basegame2(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_basegame2(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_basegame2(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_basegame2(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_basegame2(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_basegame2(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_basegame2(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_basegame2(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_basegame2(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_basegame2(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_basegame2(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_basegame2(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_basegame2(inputs)
	if (locale === "th") return th_offerdetail_achievements_basegame2(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_basegame2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_basegame2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_basegame2(inputs)
	return ko_offerdetail_achievements_basegame2(inputs)
});
export { offerdetail_achievements_basegame2 as "offerDetail.achievements.baseGame" }